import { render, staticRenderFns } from "./industrial-detail.vue?vue&type=template&id=40e52964&scoped=true&"
import script from "./industrial-detail.vue?vue&type=script&lang=js&"
export * from "./industrial-detail.vue?vue&type=script&lang=js&"
import style0 from "./industrial-detail.vue?vue&type=style&index=0&id=40e52964&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e52964",
  null
  
)

export default component.exports